import { ReactNode } from "react"

export const jsxJoin = (nodes:ReactNode[], separator:ReactNode, wrapper?:string[])=>{
    let result = [];
    for (let index = 0; index < nodes.length; index++) {
        const node = nodes[index];
        let useWrapper = (wrapper?.length ?? 0) > 1
        if(useWrapper && wrapper)
        {
            result.push(wrapper[0])
        }
        result.push(node)
        if(useWrapper && wrapper)
        {
            result.push(wrapper[1])
        }
        
        if(index < nodes.length -1)
        {
            result.push(separator);
        }
    }
    return result;
}